import { render, staticRenderFns } from "./VgCard.vue?vue&type=template&id=63bda59e&scoped=true&"
import script from "./VgCard.vue?vue&type=script&lang=js&"
export * from "./VgCard.vue?vue&type=script&lang=js&"
import style0 from "./VgCard.vue?vue&type=style&index=0&id=63bda59e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bda59e",
  null
  
)

export default component.exports